export default __webpack_public_path__ + "static/media/19.ee62b8a6.jpg";